module.exports = __webpack_public_path__ + "static/media/saude.c9b529a1.png";